import React, { useRef, createRef } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import './page-transitions.css';

export default function PageTransitionLayout() {
  const location = useLocation();
  // Map de refs por rota para evitar findDOMNode
  const nodeRefs = useRef({});
  const getNodeRef = (key) => {
    if (!nodeRefs.current[key]) nodeRefs.current[key] = createRef();
    return nodeRefs.current[key];
  };
  const nodeRef = getNodeRef(location.pathname);

  // mode="out-in": a rota antiga sai e SÓ ENTÃO a nova entra — sem as duas
  // empilhadas (o antigo "in-out" segurava 500ms + 700ms e dava o struggle).
  // A transição é só CSS (.fade-ocean) — sem anime.js redundante por cima.
  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={location.pathname}
        nodeRef={nodeRef}
        classNames="fade-ocean"
        timeout={{ enter: 380, exit: 240 }}
        mountOnEnter
        unmountOnExit
        appear
      >
        <div ref={nodeRef} className="route-container">
          <Outlet />
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
}